// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__cDizS","loaderOuter":"PageOverlayLoader_loaderOuter__30LzL"};